export default "__VITE_ASSET__NhOH99aU__"